// extracted by mini-css-extract-plugin
export default {"item":"columnItem_item__6l8JM"};